module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"registrant":"Melder","backoffice":"Backoffice"},"fr":{"backoffice":"Secrétariat","registrant":"Déclarant"},"it":{"backoffice":"Backoffice","registrant":"Notificante"}}')
  delete Component.options._Ctor
}
